import { mapGetters } from 'vuex';
import dayjs from 'dayjs';
// import dealProductLinkMixin from '@/mixins/dealProductLink';

const customParseFormat = require('dayjs/plugin/customParseFormat');

dayjs.extend(customParseFormat);

export default {
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    isBig: {
      type: Boolean,
      default: false,
    },
    dealCatetoryId: {
      type: String,
      default: null,
    },
  },
  // mixins: [dealProductLinkMixin],
  computed: {
    ...mapGetters({
      lang: 'GET_LANGUAGE',
      isRTLPage: 'GET_IS_RLT_PAGE',
      isLanding: 'GET_IS_LANDING_PAGE',
      device: 'GET_DEVICE',
      marketerId: 'GET_MARKETER_ID',
      isMemberLogin: 'IS_AUTHORIZED',
      memberDiscountPercent: 'GET_DISCOUNT_PERCENT',
      isOdysseySite: 'GET_ODYSSEY_AGENT_STATE',
      isFCLAgent: 'IS_FCL_ODYSSEY_AGENT_CODE',
      landingInfo: 'GET_LANDING_INFO',
    }),
    item() {
      const valueArray = this.items[1];
      const rawItem = (valueArray) ? valueArray[0] : null;
      
      // If it's a liveshow product, map the fields
      if (rawItem && rawItem.isLiveshowProduct) {
        return {
          ...rawItem,
          checkinDate: rawItem.event_start?.replace(' ', 'T'),
          checkoutDate: rawItem.event_end?.replace(' ', 'T'),
        };
      }
      
      return rawItem;
    },
    moreItems() {
      const valueArray = this.items[1];
      return (valueArray && valueArray.length > 1) ? valueArray.slice(1) : [];
    },
    isBadge() {
      return this.item?.badgeColor && this.item?.badgeText;
    },
    isTimer() {
      // For liveshow products, use sale_timer if available
      if (this.item?.isLiveshowProduct && this.item?.sale_timer) {
        return new Date(this.item.sale_timer) > new Date();
      }
      return this.item?.specialDiscount && this.item?.specialDiscount.endDate && new Date(this.item?.specialDiscount.endDate) > new Date();
    },
    discountPercent() {
      // For liveshow products, use discount field
      if (this.item?.isLiveshowProduct) {
        return this.item?.discount || 0;
      }
      return (this.item?.specialDiscount?.discountPercent && new Date(this.item?.specialDiscount?.endDate) > new Date()) ? this.item?.specialDiscount?.discountPercent : this.item?.appliedDiscountPercent;
    },
    imageUrl() {
      const { item } = this;
      let url = '';

      if (!item) return '';
      
      // For liveshow products, use image_url directly
      if (item.isLiveshowProduct) {
        return item.image_url || 'assets/img/lesiurpackages_hotelsimg5.jpg';
      }
      
      url = (item.imageUrl !== 'null') ? url = item.imageUrl : null;
      url = url || item?.extendedProperties?.hotelInfo?.mainImageUrls?.[0] || item?.extendedProperties?.hotelConversion?.imageUrl || 'assets/img/lesiurpackages_hotelsimg5.jpg';
      return url;
    },
    productPageLink() {
      const { marketerId, item, imageUrl, landingInfo } = this;
      
      // For liveshow products, use online_order_link
      if (item?.isLiveshowProduct) {
        return item.online_order_link || '#';
      }
      
      const utmSourceParam = landingInfo?.utm_source ? `&utm_source=${landingInfo.utm_source}` : '';
      let url = item.productPageUrl;
      if (url.includes('&lang=')) {
        url.replace(/&lang=\w+/, `&lang=${this.lang}`);
      } else {
        url += `&lang=${this.lang}`;
      }
      url += `&dealId=${item.id}&mainimg=${imageUrl}&dealCategoryId=${this.dealCatetoryId}${utmSourceParam}`;
      if (marketerId && marketerId !== '') url = `${url}&marketerId=${marketerId}`;

      return url;
    },
    discountedPrice() {
      // For liveshow products, calculate price with discount
      if (this.item?.isLiveshowProduct) {
        const price = this.item.price || 0;
        const discount = this.item.discount || 0;
        return Math.round(price * (1 - discount / 100));
      }
      
      const { totalAfterDiscount, totalPrice } = this.item;
      if (this.isOdysseySite && !this.isFCLAgent) return Math.round(totalPrice);
      if (!this.isMemberLogin) return Math.round(totalAfterDiscount);

      const isAtlantis = this.item.atlantisDiscounted;
      const isCreditCardRemarkHotel = this.item.cardRemarkDiscounted;
      const { memberDiscountPercent } = this;
      const price = (isAtlantis || isCreditCardRemarkHotel) ? totalAfterDiscount : totalAfterDiscount * (1 - memberDiscountPercent / 100);
      return Math.round(price);
    },
    remark() {
      return this.supplierName === 'ATLANTIS' ? this.item?.roomRemark?.trim() || '' : '';
    },
    supplierName() {
      const { item } = this;
      if (item?.isLiveshowProduct) return 'LIVESHOW';
      const { extendedProperties } = item;
      return extendedProperties?.sourceName;
    },
    commission() {
      const { isFCLAgent, item } = this;
      const { extendedProperties } = item;
      if (extendedProperties?.sourceName === 'ATLANTIS') return 5;
      let { commission } = extendedProperties?.hotelConversion;
      if (!isFCLAgent) {
        commission = Number(commission) - 5;
      }
      return commission;
    },
    isOfirQuery() {
      return this.$route.query.dealOrderTesting === 'true';
    },
    isMobile() {
      return this.device === 'mobile';
    },
  },
  watch: {
    lang() {
      // console.log(this.lang);
    },
  },
  data() {
    return {
      mainProps: {
        blankColor: '#bbb',
        class: 'card-img-top img-fluid',
      },
      isSalesDealExpired: false,
    };
  },
  methods: {
    changeDateFormat(str) {
      if (!str) return '';
      return str.split('T')[0].split('-').reverse().join('/');
    },
    calcNight(day1, day2) {
      if (!day1 || !day2) return 0;
      // Calculate nights by using the date part only (ignoring time)
      return dayjs(day1).startOf('day').diff(dayjs(day2).startOf('day'), 'day');
    },
    finishCountdown() {
      this.isSalesDealExpired = true;
    },
  },
};
